import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from 'src/app/services/form.service';
import { FormGroup } from '@angular/forms';
import { SesionService } from 'src/app/services/sesion.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { ModalService } from 'src/app/services/modal.service';
import { UtilsService } from 'src/app/services/utils.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { AppConstants } from 'src/app/app.constants';

@Component({
  selector: 'app-contraseniamodal',
  templateUrl: './contraseniamodal.component.html',
  styleUrls: ['./contraseniamodal.component.css']
})
export class ContraseniamodalComponent implements OnInit {

  @Input() data;
  form: FormGroup;
  submitted: Boolean = false;
  sesion: any;
  showOldPassword: Boolean = false;
  showNewPassword: Boolean = false;
  showConfirmPassword: Boolean = false;

  constructor(private activeModal: NgbActiveModal, private formService: FormService, private sesionService: SesionService, private usuarioService: UsuarioService, private alertService: NotificacionesService, private modalService: ModalService, private utils: UtilsService) { }

  ngOnInit(): void {
    this.form = this.formService.getContraseniaModalForm(this.data);
    this.sesion = this.sesionService.getSesionData();
  }

  save() {
    this.submitted = true;
    if (this.form.invalid)
      return;
    let usuarioCredentials = {
      nombreUsuario: this.form.getRawValue().usuario,
      contrasenaAnterior: this.form.getRawValue().contrasenaAnterior,
      contrasenaNueva: this.form.getRawValue().contrasenaNueva
    };
    this.modalService.mostrarModalCargando();
    this.usuarioService.actualizaContrasena(usuarioCredentials).subscribe((data: any) => {
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.sesion.contrasena = usuarioCredentials.contrasenaNueva;
        this.sesion.contrasenaEfimera = 0;
        this.sesionService.setSesionData(this.sesion);
        this.alertService.success(data.mensaje, true);
        this.close();
      }
      else {
        this.alertService.error(data.mensaje, true);
      }
      this.modalService.cerrarModalCargando();
    }, (error: any) => {
      console.error('Error', error);
      this.alertService.error('No se pudo actualizar su contraseña, intente de nuevo.', true);
      this.modalService.cerrarModalCargando();
    });
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  close() {
    this.activeModal.close();
  }

  showHideOldPassword() {
    this.showOldPassword = !this.showOldPassword;
  }

  showHideNewPassword() {
    this.showNewPassword = !this.showNewPassword;
  }

  showHideConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

}
